module.exports = __webpack_public_path__ + "static/media/logo_bottom.26f493f9.png";